import React, { Component, Fragment } from 'react';
import PartnerHeader from './PartnerHeader';
import { inject, observer } from 'mobx-react';
import PartnerManagementStore from '../../stores/PartnerManagementStore';
import Select from 'react-select';
import SwitchButton from 'lyef-switch-button';
import { getFromLocalStorage } from '../../services/utils';
import { getCity } from '../../services/cities';
import Loading from '../Loading';
import { DateInput } from '@blueprintjs/datetime';
import moment from 'moment';
import { saveToLocalStorage } from "../../services/utils";

const base = 'partner-management';

@inject('PartnerManagementStore', 'UserStore')
@observer
class EditPartner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isPhoneValid: true,
      isIcNumberValid: true,
      isEmergencyContactNumberValid: true
    }
  }

  componentDidMount() {
    PartnerManagementStore.fetchRiderInfo();
  }

  handleGoBack = () => {
    saveToLocalStorage('riderId', null);
    history.goBack();
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { history } = this.props;
    let data = PartnerManagementStore.riderInfo.data;
    if (!data.role) {
      this.setState({ error : 'role'});
      return;
    }

    if (!data.bank_name) {
      this.setState({ error : 'bank_name'})
      return;
    }

    if (!data.outlet_partner_info.position) {
      this.setState({ error : 'position'})
      return;
    }

    if ((data.role == "Driver" || (data.role === "OutletPartner" && !data.outlet_partner_info.outlet_partner_type)) && !data.outlet) {
      this.setState({ error : 'outlet'})
      return;
    }

    if (data.role === "OutletPartner" && !data.outlet_partner_info.outlet_partner_type) {
      this.setState({ error : 'partner_type'})
      return;
    }

    if (data.role === "OutletPartner" && !data.outlet_partner_info.date_joined) {
      this.setState({ error : 'date_joined'})
      return;
    }

    PartnerManagementStore.handleSavePartner().then((response) => {
      if (response === "Successfully Added") {
        history.goBack();
      }
    });
  }

  handleSetSelectedUserType = (userType) => {
    PartnerManagementStore.setSelectedUserType(userType);
  }

  handleSetSelectedOutletPartnerType= (outletPartnerType) => {
    PartnerManagementStore.setSelectedOutletPartnerType(outletPartnerType);
  }

  handleSetSelectedPosition = (position) => {
    PartnerManagementStore.setSelectedPosition(position);
  }

  handleSetSelectedRiderType = (riderType) => {
    PartnerManagementStore.setSelectedRiderType(riderType);
  }

  handleSetSelectedBasedInOutlet = (outlet) => {
    PartnerManagementStore.setSelectedBasedInOutlet(outlet);
  }

  handleSetSelectedBankName = (bankName) => {
    PartnerManagementStore.setSelectedBankName(bankName);
  }

  handleSetSelectedRiderRank = (riderRank) => {
    PartnerManagementStore.setSelectedRiderRank(riderRank);
  }

  handleSetSelectedRiderLeader= (riderLeader) => {
    PartnerManagementStore.setSelectedRiderLeader(riderLeader);
  }

  handleCheckboxChange = (hubCode) => {
    let prevSelectedHubs = PartnerManagementStore.riderInfo.data.hub_codes;
    let selectedHubs = prevSelectedHubs;
    if (selectedHubs.includes(hubCode)) {
        selectedHubs = selectedHubs.filter((code) => code !== hubCode);
    } else {
        selectedHubs = [...selectedHubs, hubCode];
    }
    PartnerManagementStore.setSelectedHubs(selectedHubs)
  };

  handleDateChange = (date, field) => {
    PartnerManagementStore.setDate(date, field);
  }

  handleTerminalRiderToggle = () => {
    let isTerminalRider = PartnerManagementStore.riderInfo.data.terminal_rider;
    PartnerManagementStore.setTerminalRider(!isTerminalRider)
  }

  handleMobilenoChange = (e) => {
    const value = e.target.value;
    const isValid = /^(\+|0)(\d{4,18})$/.test(value);

    this.setState({ isPhoneValid: isValid });
    PartnerManagementStore.setMobileNumber(value);
  };

  handleIcNumberChange = (e) => {
    const value = e.target.value;
    const isValid = /^(\'|)(\d{12,12})$/.test(value);

    this.setState({ isIcNumberValid: isValid });
    PartnerManagementStore.setICNumber(value)
  };

  handleEmergencyMobilenoChange = (e) => {
    const value = e.target.value;
    const isValid = /^(\+|0)(\d{4,18})$/.test(value);

    this.setState({ isEmergencyContactNumberValid: isValid });
    PartnerManagementStore.setEmergencyContactNumber(value);
  };

  handleInsuranceToggle =() => {
    let isInsured = PartnerManagementStore.riderInfo.data.insurance;
    PartnerManagementStore.setInsurance(!isInsured)
  }

  render() {
    const {
        PartnerManagementStore: {
            setFirstName,
            setLastName,
            userTypeOptions,
            positionOptions,
            outletPartnerTypeOptions,
            setEmail,
            setGoogleSheetLink,
            riderTypeOptions,
            setThirdPartyRiderCompany,
            setEmergencyContactName,
            setLegalName,
            bankNameOptions,
            setBankAccountNumber,
            setCompanyBankSubAccount,
            setHomeAddress,
            setBrioId,
            riderRankOptions,
            riderLeaderOptions,
            riderInfo
        },
        UserStore: {
         position,
         selectedHub
        }
    } = this.props;

    const { error, isPhoneValid, isIcNumberValid, isEmergencyContactNumberValid } = this.state;

    if (!riderInfo || !riderInfo.data) {
      return <Loading />
    }

    const hubsList = getFromLocalStorage('hubsList') || [];
    let hubsInCurrentCity = hubsList.filter(hub => hub.city === getCity());
    
    if (position != "Territory Manager") {
      hubsInCurrentCity = hubsList.filter(hub => hub.value === selectedHub.value)
    }

    return (
      <Fragment>
          <PartnerHeader title='Edit/Add Rider or Outlet Partner' />
          {riderInfo.suspended && (
            <div className="alert alert-danger">
              <h4>This rider is suspended until {riderInfo.suspension_end_date}</h4>
              <p>Reason: {riderInfo.suspension_reason}</p>
              <p>Suspension Category: {riderInfo.suspension_category}</p>
            </div>
          )}
        <form className='pm' style={{ maxWidth: '1200px' }} onSubmit={this.handleSubmit}>
        <div
            className={`grid grid-1-1`}
        >
            <label className='fs--medium-medium-large'>Rider #</label>
            <input
                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                type='text'
                value={riderInfo.data.user_id}
                disabled
            />

            <label className='fs--medium-medium-large'>First Name</label>
            <input
                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                type='text'
                value={riderInfo.data.firstname}
                onChange={setFirstName}
                required
            />

            <label className='fs--medium-medium-large'>Last Name</label>
            <input
                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                type='text'
                value={riderInfo.data.lastname}
                onChange={setLastName}
            />

            <label className='fs--medium-medium-large'>User Type</label>
            <div>
            <Select
                className='fs--medium-medium-large'
                value={userTypeOptions.find(opt => opt.value === riderInfo.data.role)}
                options={userTypeOptions}
                style={{ width: '100%', marginBottom: '10px' }}
                name='userType'
                onChange={this.handleSetSelectedUserType}
                placeholder='Choose a user type'
                required
            />
            {error == "role" && (
              <span className='text--red'>Please choose a user type</span>
            )}

            </div>
            
            {riderInfo.data.role && (
              <>
                <label className='fs--medium-medium-large'>Hubs</label>
                <div className="col-xs-9 col-lg-8 selectContainer text--left">
                  {hubsInCurrentCity.map((hub) => (
                    <div key={hub.value}>
                      <input
                        type="checkbox"
                        name="hubs"
                        checked={riderInfo.data.hub_codes ? riderInfo.data.hub_codes.includes(hub.value) : false}
                        onChange={() => this.handleCheckboxChange(hub.value)}
                        className='mrm'
                      />
                      {hub.value}
                    </div>
                  ))}
                </div>

                {riderInfo.data.role === "OutletPartner" && (
                  <>
                    <label className='fs--medium-medium-large'>Outlet Partner Type</label>
                    <div>
                      <Select
                          className='fs--medium-medium-large'
                          value={outletPartnerTypeOptions.find(opt => opt.value === riderInfo.data.outlet_partner_info.outlet_partner_type)}
                          autoFocus
                          required
                          options={outletPartnerTypeOptions}
                          style={{ width: '100%', marginBottom: '10px' }}
                          name='unitSkus'
                          onChange={this.handleSetSelectedOutletPartnerType}
                          placeholder='Choose a outlet partner type'
                      />
                      <br/>
                      {error == "partner_type" && (
                          <span className='text--red'>Please select a partner type</span>
                      )}
                    </div>
                  </>
                )}
                
                {(riderInfo.data.role != "OutletPartner" || 
                (riderInfo.data.role === "OutletPartner" && riderInfo.data.outlet_partner_info.outlet_partner_type)) && (
                    <>
                      <label className='fs--medium-medium-large'>Position</label>
                      <div>
                        <Select
                            className='fs--medium-medium-large'
                            value={positionOptions.find(opt => opt.value === riderInfo.data.outlet_partner_info.position)}
                            autoFocus
                            required
                            options={positionOptions}
                            style={{ width: '100%', marginBottom: '10px' }}
                            name='unitSkus'
                            onChange={this.handleSetSelectedPosition}
                            placeholder='Choose a position'
                        />
                        {error == "position" && (
                          <span className='text--red'>Please choose a position</span>
                        )}
                      </div>

                      <label className='fs--medium-medium-large'>Email Id</label>
                      <input
                            className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                            type='text'
                            value={riderInfo.data.email}
                            onChange={setEmail}
                            required
                      />
                      {riderInfo.data.role != "OutletPartner" && (
                        <>
                          <label className='fs--medium-medium-large'>Username</label>
                          <input
                              className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                              type='text'
                              value={riderInfo.data.username}
                              readOnly
                          />
                          <label className='fs--medium-medium-large'>OTP</label>
                          <input
                              className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                              type='text'
                              value={riderInfo.data.one_time_password}
                              readOnly
                          />

                          <label className='fs--medium-medium-large'>Google Sheet Link</label>
                          <input
                                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                                type='text'
                                value={riderInfo.data.google_sheet_link}
                                onChange={setGoogleSheetLink}
                          />
                        </>
                      )}
                      {(riderInfo.data.google_sheet_link  && riderInfo.data.google_sheet_link.match(/^[a-zA-Z]+:\/\//)) && (
                        <>
                          <label className='fs--medium-medium-large' />
                          <a className="btn btn-primary" target="_blank"
                                href={riderInfo.data.google_sheet_link}>
                                  Go to google sheet
                          </a>
                        </>
                      )}
                      
                      {(riderInfo.data.role === "Driver"  || riderInfo.data.role === "InactiveDriver") && (
                        <>
                          <label className='fs--medium-medium-large'>Rider Type</label>
                          <Select
                              className='fs--medium-medium-large'
                              value={riderTypeOptions.find(opt => opt.value === riderInfo.data.rider_type)}
                              autoFocus
                              required
                              options={riderTypeOptions}
                              style={{ width: '100%', marginBottom: '10px' }}
                              name='unitSkus'
                              onChange={this.handleSetSelectedRiderType}
                              placeholder='Choose a position'
                          />
                        </>
                      )}

                        {(riderInfo.data.role === "Driver" || 
                          (riderInfo.data.role === "OutletPartner" && riderInfo.data.outlet_partner_info.outlet_partner_type)) && (
                              <>
                                <label className='fs--medium-medium-large'>Based in which outlet</label>
                                <div>
                                  <Select
                                      className='fs--medium-medium-large'
                                      value={hubsList.find(opt => opt.value === riderInfo.data.outlet)}
                                      autoFocus
                                      required
                                      options={hubsList}
                                      style={{ width: '100%', marginBottom: '10px' }}
                                      name='unitSkus'
                                      onChange={this.handleSetSelectedBasedInOutlet}
                                      placeholder='Choose a outlet'
                                  />
                                  <br/>
                                  {error == "outlet" && (
                                      <span className='text--red'>Please select an outlet</span>
                                  )}
                                </div>
                              </>
                        )}

                        {riderInfo.data.rider_type === "THIRD_PARTY_RIDER" && (
                          <>
                            <label className='fs--medium-medium-large'>3PL Company</label>
                            <input
                                  className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                                  type='text'
                                  value={riderInfo.data.third_party_rider_company}
                                  onChange={setThirdPartyRiderCompany}
                                  required
                            />
                          </>
                        )}
                        
                        {riderInfo.data.role != "OutletPartner" && (
                          <>
                            <label className='fs--medium-medium-large'>Terminal Rider</label>
                            <SwitchButton
                                id={`switch_button_${riderInfo.data.id}`}
                                isChecked={ riderInfo.data.terminal_rider }
                                action={() => this.handleTerminalRiderToggle()}
                                disabled={false}
                                className='text--left mrm'
                            />
                          </>
                        )}

                          {/* <label className='fs--medium-medium-large'>Cities</label>
                          <div className='text--left'>
                            <input
                                type="checkbox"
                                name="hubs"
                                checked={riderInfo.data.city === 'Kuala_Lumpur'}
                                onChange={() => this.handleCheckboxChange(hub.value)}
                                className='mrm'
                            />
                            Kuala Lumpur
                          </div> */}

                          <label className='fs--medium-medium-large'>Phone number</label>
                          <div className='text--left'>
                            <input
                                  className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--100 ps mtm'
                                  type='text'
                                  value={riderInfo.data.mobileno}
                                  onChange={this.handleMobilenoChange}
                                  required
                            />
                            <br /> 
                            {!isPhoneValid && (<small className='text--red'> Please enter a valid Phone Number</small>)}
                            <br />
                            <small className="text--gray">Phone number should be in Country format +60XXXXXXXXX</small>
                          </div>

                          <label className='fs--medium-medium-large'>Emergency Contact Name</label>
                          <input
                                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                                type='text'
                                value={riderInfo.data.emergency_contact.name}
                                onChange={setEmergencyContactName}
                                required
                            />

                          <label className='fs--medium-medium-large'>Emergency Contact Number</label>
                          <div className='text--left'>
                            <input
                                  className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--100 ps mtm'
                                  type='text'
                                  value={riderInfo.data.emergency_contact.mobile_no}
                                  onChange={this.handleEmergencyMobilenoChange}
                                  required
                            />
                            <br />
                            {!isEmergencyContactNumberValid && (
                              (<small className='text--red'> Please enter a valid Phone Number</small>)
                            )}
                            <br />
                            <small className="text--gray">Phone number should be in Country format +60XXXXXXXXX</small>
                          </div>

                          <label className='fs--medium-medium-large'>IC Number</label>
                          <div className='text--left'>
                            <input
                                  className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--100 ps mtm'
                                  type='text'
                                  value={riderInfo.data.ic_number}
                                  onChange={this.handleIcNumberChange}
                                  required
                            />
                            <br/>
                            {!isIcNumberValid && (
                              <small className='text--red'>Please enter valid IC Number.</small>
                            )}
                          </div>

                          <label className='fs--medium-medium-large'>
                            {riderInfo.data.role === "OutletPartner" ? "Full name as per I/C" : "Full Legal Name"}
                          </label>
                          <input
                                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                                type='text'
                                value={riderInfo.data.legal_name}
                                onChange={setLegalName}
                                required
                          />

                          <label className='fs--medium-medium-large'>Bank Name</label>
                          <div>
                            <Select
                                className='fs--medium-medium-large'
                                value={bankNameOptions.find(opt => opt.value === riderInfo.data.bank_name)}
                                autoFocus
                                required
                                options={bankNameOptions}
                                style={{ width: '100%', marginBottom: '10px' }}
                                name='unitSkus'
                                onChange={this.handleSetSelectedBankName}
                                placeholder='Choose a bank name'
                            />
                            <br/>
                            {error == "bank_name" && (
                              <span className='text--red'>Please select bank name</span>
                            )}
                          </div>

                          <label className='fs--medium-medium-large'>Bank Account No.</label>
                          <input
                                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                                type='text'
                                value={riderInfo.data.bank_account_number}
                                onChange={setBankAccountNumber}
                                required
                            />

                          <label className='fs--medium-medium-large'>Company Bank Account Sub Number</label>
                          <input
                                className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--400px ps mtm'
                                type='text'
                                value={riderInfo.data.company_bank_sub_account}
                                onChange={setCompanyBankSubAccount}
                            />

                          {riderInfo.data.role === "OutletPartner" && (
                            <>
                              <label className='fs--medium-medium-large'>Date Joined</label>
                              <div className='display--flex justify--space-between flex-align-items-center'>
                                <DateInput
                                      formatDate={ (date) => moment(date).format('DD/MM/YYYY') }
                                      onChange={ (date) => this.handleDateChange(date, 'date_joined') }
                                      parseDate={ (str) => moment(str, 'DD/MM/YYYY').toDate() }
                                      placeholder="Date"
                                      value={ riderInfo.data.outlet_partner_info.date_joined ? moment(riderInfo.data.outlet_partner_info.date_joined, 'DD/MM/YYYY').toDate() : null }
                                      required
                                      className={`${base}__date_input`}
                                />
                                  <br/>
                                  {error === 'date_joined' && (
                                    <span className='text--red'>Please set joining date</span>
                                  )}
                              </div>

                              <label className='fs--medium-medium-large'>Resignation Date</label>
                              <div className='display--flex justify--space-between flex-align-items-center'>
                                <DateInput
                                      formatDate={(date) => moment(date).format('DD/MM/YYYY')
                                      }
                                      onChange={ (date) => this.handleDateChange(date, 'resignation_date') }
                                      parseDate={(str) => moment(str, 'DD/MM/YYYY').toDate() }
                                      placeholder="Date"
                                      value={riderInfo.data.outlet_partner_info.resignation_date  ? moment(riderInfo.data.outlet_partner_info.resignation_date, 'DD/MM/YYYY').toDate() : null}
                                      className={`${base}__date_input`}
                                  />
                              </div>
                              <label className='fs--medium-medium-large'>Home Address</label>
                              <div className='text--left'>
                                <input
                                      className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--100 ps mtm'
                                      type='text'
                                      value={riderInfo.data.home_address}
                                      onChange={setHomeAddress}
                                />
                                <br />
                                <small className="text--gray">Address should be in this format: Unit Number, Building Name (If applicable), Street, City, Postcode, State</small>
                              </div>
                            </>
                          )}
                          <label className='fs--medium-medium-large'>Insurance</label>
                          <SwitchButton
                              id={`switch_${riderInfo.data.id}`}
                              isChecked={
                                  riderInfo.data.insurance
                              }
                              action={() => this.handleInsuranceToggle()}
                              disabled={false}
                              className='text--left mrm'
                          />
                          {riderInfo.data.role != "OutletPartner" && (
                            <>
                              <label className='fs--medium-medium-large'>Rider Rank</label>
                              <Select
                                  className='fs--medium-medium-large'
                                  value={riderRankOptions.find(opt => opt.value === riderInfo.data.rank)}
                                  autoFocus
                                  required
                                  options={riderRankOptions}
                                  style={{ width: '100%', marginBottom: '10px' }}
                                  name='unitSkus'
                                  onChange={this.handleSetSelectedRiderRank}
                                  placeholder='Choose a rank'
                              />
                            </>
                          )}

                          {riderInfo.data.rank && riderInfo.data.rank === "RIDER" && (
                            <>
                              <label className='fs--medium-medium-large'>Rider Leader</label>
                              <Select
                                  className='fs--medium-medium-large'
                                  value={riderLeaderOptions.find(opt => opt.value === riderInfo.data.rider_leader)}
                                  autoFocus
                                  required
                                  options={riderLeaderOptions}
                                  style={{ width: '100%', marginBottom: '10px' }}
                                  name='unitSkus'
                                  onChange={this.handleSetSelectedRiderLeader}
                                  placeholder='Choose a leader'
                              />
                            </>
                          )}
                          <label className='fs--medium-medium-large'>Brio Id</label>
                              <div className='text--left'>
                                <input
                                      className='border--rounded border--solid fs--medium-medium-large text--black text--bolder width--100 ps mtm'
                                      type='text'
                                      value={riderInfo.data.brio_id}
                                      onChange={setBrioId}
                                />
                              </div>
                          <label className='fs--medium-medium-large'>Created on</label>
                          <div className='display--flex justify--space-between flex-align-items-center'>
                          <DateInput
                            placeholder="Date"
                            value={
                              riderInfo.data.created_date
                                ? moment(riderInfo.data.created_date).toDate()
                                : null
                            }
                            disabled
                            formatDate={(date) => moment(date).format('DD/MM/YYYY')}
                            parseDate={(str) => moment(str, 'DD/MM/YYYY').toDate()}
                            className={`${base}__date_input`}
                          />
                          </div>
                  </>
                  )}
              </>
          )}

          

            </div>
          <button className="btn btn-primary mtm" type="submit">Update</button>
        </form>
      </Fragment>
    );
  }
}

export default EditPartner;